export const SHIPPING_EXEMPT_CATEGORIES = ['svgfiles'] as const;

export type ShippingExemptCategory = (typeof SHIPPING_EXEMPT_CATEGORIES)[number];

export interface ShippingAddress {
  fullName: string;
  city: string;
  street: string;
  streetNumber: string;
  flat?: string;
  notes?: string;
  phone: string;
}

export function defaultRecipientFullName(
  firstName?: string,
  lastName?: string
): string {
  return [firstName?.trim(), lastName?.trim()].filter(Boolean).join(' ');
}

export function requiresShippingAddress(
  items: { productType: string; category?: string; isCustomizable?: boolean }[]
): boolean {
  return items.some(
    (i) =>
      i.productType === 'Item' &&
      // !i.isCustomizable &&
      (!i.category ||
        !SHIPPING_EXEMPT_CATEGORIES.includes(i.category as ShippingExemptCategory))
  );
}

export function normalizeShippingAddress(
  address?: Partial<ShippingAddress> | null,
  fallbackFullName = ''
): ShippingAddress {
  return {
    fullName: address?.fullName?.trim() || fallbackFullName,
    city: address?.city?.trim() ?? '',
    street: address?.street?.trim() ?? '',
    streetNumber: address?.streetNumber?.trim() ?? '',
    flat: address?.flat?.trim() ?? '',
    notes: address?.notes?.trim() ?? '',
    phone: address?.phone?.trim() ?? '',
  };
}

export function hasShippingAddressContent(address: ShippingAddress): boolean {
  return Boolean(
    address.fullName ||
      address.city ||
      address.street ||
      address.streetNumber ||
      address.phone
  );
}

export function isShippingAddressValid(address: ShippingAddress): boolean {
  return Boolean(
    address.fullName?.trim() &&
      address.city?.trim() &&
      address.street?.trim() &&
      address.streetNumber?.trim() &&
      address.phone?.trim()
  );
}
